import { motion } from 'motion/react';
import { FC } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import FilledIceCube from './FilledIceCube';
import EmptyIceCube from './EmptyIceCube';
import { ExitSlipResult } from '../../../models/ExitSlip';

interface Props {
  correctAnswers: ExitSlipResult[];
  wrongAnswers: ExitSlipResult[];
  isPerfectScore: boolean;
  passedScore?: boolean;
}

const IceCubesResult: FC<Props> = ({ correctAnswers, wrongAnswers, isPerfectScore, passedScore }) => {
  const URL = '/perfect-score-animation.json';
  const showsCelebration = !!passedScore;

  return (
    <div style={{ maxHeight: `${showsCelebration ? '80px' : ''}` }}>
      {passedScore && (
        <motion.div
          initial={{ opacity: 0, scale: 0, rotateY: -90 }}
          animate={{ opacity: 1, scale: 1, rotateY: 0 }}
          transition={{
            duration: 2,
            delay: 3,
            ease: [0.34, 1.56, 0.64, 1],
          }}
          className="tw-relative"
          style={{ top: '-85px' }}
        >
          <DotLottieReact src={URL} autoplay loop style={{ width: '100%', aspectRatio: '315 / 225' }} />
        </motion.div>
      )}
      <div
        className={`tw-flex tw-flex-row tw-gap-x-2 ${passedScore || isPerfectScore ? 'tw-justify-center' : ''} ${
          showsCelebration ? 'tw-relative' : ''
        }`}
        style={{ top: `${showsCelebration ? '-220px' : ''}` }}
      >
        {correctAnswers.map((_el, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0, rotateY: -90 }}
            animate={{ opacity: 1, scale: 1, rotateY: 0 }}
            transition={{
              duration: 0.7,
              delay: 0.8 + i * 0.15,
              ease: [0.34, 1.56, 0.64, 1],
            }}
          >
            <FilledIceCube />
          </motion.div>
        ))}

        {!isPerfectScore &&
          wrongAnswers.map((_el, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0, rotateY: -90 }}
              animate={{ opacity: 1, scale: 1, rotateY: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.8 + correctAnswers.length * 0.15 + i * 0.15,
                ease: [0.34, 1.56, 0.64, 1],
              }}
            >
              <EmptyIceCube />
            </motion.div>
          ))}
      </div>
    </div>
  );
};

export default IceCubesResult;
